
import './Statistica.css';
import { useState } from "react";
import ReactModal from "react-modal";
import React from "react";
import CloseIcon from '@mui/icons-material/Close';
import BillingNotes from './BillingNotes';

type PropsType = {
    showCanceledClients: boolean
    setShowCanceledClients: (show: boolean) => void
    clientData: any
    setClientData: (data: any) => void
}

function CancelTypeData(props: PropsType) {

    const {
        showCanceledClients,
        setShowCanceledClients,
        clientData,
        setClientData
    } = props;

    const [showNotes, setShowNotes] = useState<boolean>(false);
    const [currentClient, setCurrentClient] = useState<any>(null);
    const [isServiceReason] = useState<boolean>(clientData?.id === "Dissatisfaction with the quality of service");

    const closeModal = (): void => {
        setClientData(null);
        setShowCanceledClients(false)
    }

    const openNotesModal = (client: any) => {
        setCurrentClient(client);
        setShowNotes(true);
    }

    return (
        <ReactModal
            isOpen = { showCanceledClients }
            onRequestClose = { closeModal }
            bodyOpenClassName = 'no-scroll'
            style = {{
                overlay: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.2)',
                    zIndex: 300,
                },
                content: {
                    position: 'relative',
                    top: '50%',
                    left: '50%',
                    right: 'auto',
                    bottom: 'auto',
                    transform: 'translate(-50%, -50%)',
                    width: "80%",
                    maxWidth: '550px',
                    maxHeight: "400px",
                    height: "auto",
                    border: 'none',
                    borderRadius: "10px",
                    background: 'white',
                    WebkitOverflowScrolling: 'touch',
                    outline: 'none',
                    overflowY: "auto",
                    display: "flex",
                    flexDirection: 'column',
                    alignItems: "center",
                    justifyContent: "flex-start",
                }
            }}
        >
            <CloseIcon
                style = {{
                    position: 'absolute',
                    right: '15px',
                    top: '15px',
                    color: 'gray',
                    cursor: 'pointer',
                }}
                onClick = { closeModal }
            />
            <div
                className='modal-deleteClient-content'
                style = {{
                    fontSize: '20px',
                    fontWeight: 'bold',
                    marginBottom: '10px'
                }}
            >
                { clientData.id }
            </div>
            {
                clientData.clients.map((client: any) => {
                    if (clientData.key === 'Other') {
                        return (
                            <span className='canceled-clients-data-name-other-text'>
                                { `${client.fullName}  (${client.cancellationOtherText})` }
                            </span>
                        )
                    }
                    else {
                        return (
                            <span
                                className='canceled-clients-data-name-text'
                                style = {{
                                    cursor: isServiceReason ? 'pointer' : 'default',
                                }}
                                onClick = { () => openNotesModal(client)}
                            >
                                { client.fullName }
                            </span>
                        )
                    }
                })
            }
            {
                isServiceReason &&
                    <BillingNotes
                        showNotes = { showNotes }
                        setShowNotes = { setShowNotes }
                        currentClient = { currentClient }
                        setCurrentClient = { setCurrentClient }
                    />
            }
        </ReactModal>
    )
}

export default CancelTypeData;

